import { createContext, useContext } from 'react';

const AIFlightDealsContext = createContext();

export const useAIFlightDeals = () => useContext(AIFlightDealsContext);

export default AIFlightDealsContext;
